import { render, staticRenderFns } from "./addWithdraw.vue?vue&type=template&id=4e838bb5"
import script from "./addWithdraw.vue?vue&type=script&lang=js"
export * from "./addWithdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports